import { createContext, useContext } from 'react';
export const ProductLoadingContext = /*#__PURE__*/createContext(undefined);
export const useIsProductLoading = () => {
  const context = useContext(ProductLoadingContext);
  if (context === undefined) {
    throw new Error('ProductLoadingContext data is undefined. useIsProductLoading must be used within a ProductLoadingContext.Provider');
  }
  return context;
};